/**
 * Labstep
 *
 * @module components/Group/Form/ShowEdit/CustomIdentifierSet/ProtocolCollection
 * @desc Action to set CustomIdentifierSet for ProtocolCollection
 */

import { CustomIdentifierSetActionCreate } from 'labstep-web/components/CustomIdentifierSet/Action/Create';
import { CustomIdentifierSetPreview } from 'labstep-web/components/CustomIdentifierSet/Preview';
import { useHasAccessCreate } from 'labstep-web/components/Entity/Can/hooks';
import { TextPlaceholder } from 'labstep-web/core/Text/Placeholder';
import { CustomIdentifierSet } from 'labstep-web/models/custom-identifier-set.model';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import type { GroupFormShowEditCustomShowIdentifierSetProtocolCollectionProps } from './types';

export const GroupFormShowEditCustomShowIdentifierSetProtocolCollection: React.FC<
  GroupFormShowEditCustomShowIdentifierSetProtocolCollectionProps
> = ({ group }) => {
  const canCreate = useHasAccessCreate(
    CustomIdentifierSet.entityName,
  ) as boolean;

  // Find the custom identifier set for protocol collections
  const customIdentifierSet = group.getUniqueCustomIdentifierSet(
    ProtocolCollection.entityName,
  );

  if (customIdentifierSet) {
    return (
      <CustomIdentifierSetPreview
        customIdentifierSet={customIdentifierSet}
        canCreate={canCreate}
      />
    );
  }
  if (canCreate) {
    return (
      <CustomIdentifierSetActionCreate
        groupId={group.id}
        parentClass={ProtocolCollection.entityName}
      />
    );
  }
  return <TextPlaceholder>No Custom Identifier</TextPlaceholder>;
};
